/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import ExtApiKeyModel from 'cio/models/ext-api-key';
import ApiCredentialModel from 'cio/models/api-credential';

interface ApiCredentialsDeleteModalComponentArgs {
  key: ExtApiKeyModel | ApiCredentialModel;
  onClose(): void;
  onConfirmDelete(): void;
}

export default class ApiCredentialsDeleteModalComponent extends Component<ApiCredentialsDeleteModalComponentArgs> {
  @tracked keyNameConfirmation = '';
}
